import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
var ɵ0 = NgxBootstrapDatePickerConfigService.getDatepickerConfig, ɵ1 = NgxBootstrapDatePickerConfigService.getDaterangepickerConfig, ɵ2 = NgxBootstrapDatePickerConfigService.getDatepickerLocale;
var MyWearablesModule = /** @class */ (function () {
    function MyWearablesModule() {
    }
    return MyWearablesModule;
}());
export { MyWearablesModule };
export { ɵ0, ɵ1, ɵ2 };
